
interface charLimitParams {

    string: string
    max: number
}

/** Trims the last character of a provided string then returns the resulting string.
 * 
 * @param - { string: string, max: number}
 * @returns string
 */
const charLimit = ( { string, max }: charLimitParams ): string => {


    if ( string.length > max ) {

        return string.substring( 0, string.length-1 )
    }

    else return string

}

export default charLimit